import Queue from "../components/queue";

export default {
  name: "queue",
  install(ctx, store) {
    const queue = new Queue(store);

    const add = async function(tracklist = {}) {
      if (tracklist.tracks && tracklist.tracks.length) {
        await queue.add(tracklist.tracks);
      }
    };

    const remove = async function(track) {
      const index = queue.tracklistIds.findIndex(_track => _track === track);

      await queue.remove(track);

      if (index <= queue.index && queue.index !== 0) {
        queue.setIndex(queue.index - 1);
      }
    };

    const clear = function() {
      queue.clear();
    };

    const setIndex = function(index) {
      queue.setIndex(index);
    };

    return {
      add: add.bind(ctx),
      remove: remove.bind(ctx),
      clear: clear.bind(ctx),
      setIndex: setIndex.bind(ctx),
      get tracksStore() {
        return queue.tracksStore;
      },
      get tracklistIds() {
        return queue.tracklistIds;
      },
      get currentTrackId() {
        return queue.currentTrackId;
      },
      get currentTrack() {
        return queue.tracksStore[queue.currentTrackId];
      },
      get currentIndex() {
        return queue.index;
      }
    };
  }
};
